import { observable, action, runInAction } from 'mobx'
import { customPageService } from '../services'

export default class CustomPageStore {
  @observable customPages = []
  @observable loading = false

  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @action
  async loadCustomPages() {
    this.loading = true
    try {
      const pages = await customPageService.getAll()
      runInAction(() => {
        this.customPages = pages
        this.loading = false
      })
    } catch (error) {
      runInAction(() => {
        this.loading = false
      })
      console.error('Failed to load custom pages', error)
    }
  }
}
